import React from 'react';
import { useLanguage } from './LanguageContext';

const Header = () => {
  const { t } = useLanguage();

  return (
    <header className="header">
      <div className="logo">AI-SON</div>
      <nav className="nav-links">
        <a href="#about">{t('about')}</a>
        <a href="#catalog">{t('catalog')}</a>
        <a href="#contacts">{t('contacts')}</a>
      </nav>
      <div className="contact-info">
        <span className="phone-number">+7 707 317 18 19</span>
        
      </div>
    </header>
  );
};

export default Header;